/**
 * useModalVisibility.js
 *
 * Estado global mínimo de "existe algum modal/painel aberto agora?" — usado
 * pelo RepresentanteFab.vue pra sumir enquanto um modal está por cima dele
 * (reportado pelo usuário: o botão flutuante ficava sobreposto ao modal de
 * Gerar Passagem, cobrindo o botão "Confirmar").
 *
 * Cada componente de modal chama `useModalVisibility(refDoShow)` uma vez —
 * o composable observa esse ref e mantém uma contagem global (suporta mais
 * de um modal empilhado). Não precisa disparar evento manualmente em nenhum
 * lugar: é só passar o mesmo `show`/`modalAberto` que o modal já usa.
 */
import { ref, watch, unref, onBeforeUnmount } from 'vue'

export const anyModalOpen = ref(false)
let openCount = 0

export function useModalVisibility(showRef) {
  function onChange(isOpen) {
    openCount = isOpen ? openCount + 1 : Math.max(0, openCount - 1)
    anyModalOpen.value = openCount > 0
  }

  const stop = watch(() => unref(showRef), onChange, { immediate: true })

  onBeforeUnmount(() => {
    if (unref(showRef)) onChange(false)
    stop()
  })
}
